import { render, staticRenderFns } from "./TransportListPage.vue?vue&type=template&id=5b45d4a1&scoped=true&"
import script from "./TransportListPage.vue?vue&type=script&lang=js&"
export * from "./TransportListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b45d4a1",
  null
  
)

export default component.exports